<!-- Toast Notifications Container -->
<div class="toast-container" *ngIf="toasts.length > 0">
  <div 
    *ngFor="let toast of toasts" 
    class="toast-notification"
    [class.toast-success]="toast.type === 'success'"
    [class.toast-error]="toast.type === 'error'"
    [class.toast-warning]="toast.type === 'warning'"
    [class.toast-info]="toast.type === 'info'">
    <i class="fa" [ngClass]="getToastIcon(toast.type)"></i>
    <span class="toast-message">{{ toast.message }}</span>
    <button class="toast-close" (click)="dismissToast(toast.id)">
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>

<div class="notification-container" [class.dark-mode]="isDarkMode">
  <!-- Summary Card -->
  <div class="notification-summary-card" *ngIf="showSummary && summary.total > 0">
    <div class="summary-header" (click)="toggleSummary()">
      <i class="fa fa-chart-bar"></i>
      <span>Quick Summary</span>
      <i class="fa fa-chevron-up toggle-icon"></i>
    </div>
    <div class="summary-content">
      <div class="summary-stat" *ngIf="summary.processing > 0">
        <span class="stat-icon processing">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
        <span class="stat-text">{{ summary.processing }} processing</span>
      </div>
      <div class="summary-stat" *ngIf="summary.errors > 0">
        <span class="stat-icon errors">
          <i class="fa fa-exclamation-circle"></i>
        </span>
        <span class="stat-text">{{ summary.errors }} error{{ summary.errors > 1 ? 's' : '' }}</span>
      </div>
      <div class="summary-stat">
        <span class="stat-icon recent">
          <i class="fa fa-clock"></i>
        </span>
        <span class="stat-text">{{ summary.recentCount }} in last hour</span>
      </div>
    </div>
  </div>

  <div class="notification-header">
    <h3 class="notification-title">
      <i class="fa fa-bell"></i> Notifications
      <span *ngIf="unreadCount > 0" class="badge badge-danger unread-badge">
        {{ unreadCount }}
      </span>
    </h3>
    <div class="notification-actions">
      <button
        class="btn btn-sm btn-outline-secondary mark-read-btn"
        (click)="markAllAsRead()"
        [disabled]="unreadCount === 0"
        title="Mark all as read">
        Mark as read
      </button>
      <button
        class="btn btn-sm btn-outline-danger clear-all-btn"
        (click)="clearAllNotifications()"
        [disabled]="filteredNotifications.length === 0"
        title="Clear all notifications">
        Clear all
      </button>
    </div>
  </div>

  <!-- Filter Tabs. The wrapper lets the type dropdown share this row on a
       phone; it is display:contents above 768px, so desktop layout is
       exactly as it was. -->
  <div class="notification-filter-row">
  <!-- Filter Tabs -->
  <div class="notification-filter-tabs">
    <button
      *ngFor="let tab of filterTabs"
      class="filter-tab"
      [class.active]="selectedFilter === tab.value"
      (click)="onFilterTabChange(tab.value)">
      <i class="fa" [ngClass]="tab.icon" [class.fa-spin]="tab.value === 'processing' && summary.processing > 0"></i>
      <span class="tab-label">{{ tab.label }}</span>
      <span class="tab-count" *ngIf="getFilterCount(tab.value) > 0">
        {{ getFilterCount(tab.value) }}
      </span>
    </button>
  </div>

  <div class="notification-filters">
    <select
      class="form-control filter-select"
      [(ngModel)]="selectedType"
      (change)="onTypeFilterChange()">
      <option *ngFor="let type of notificationTypes" [value]="type.value">
        {{ type.label }}
      </option>
    </select>
  </div>

  <!-- Phones only: opens the sheet below instead of the OS select picker,
       which cannot be styled to match this UI. Hidden above 768px. -->
  <button
    type="button"
    class="type-filter-btn"
    [class.is-filtered]="selectedType !== 'all'"
    (click)="openTypeSheet()"
    [attr.aria-label]="'Filter by type: ' + selectedTypeLabel">
    <i class="fa fa-filter" aria-hidden="true"></i>
  </button>
  </div>

<!-- Type filter sheet — phones only -->
<div class="type-sheet-scrim" *ngIf="showTypeSheet" (click)="closeTypeSheet()"></div>

<div class="type-sheet" *ngIf="showTypeSheet">
  <div class="type-sheet-grab"></div>
  <div class="type-sheet-title">Filter by type</div>
  <button
    type="button"
    class="type-sheet-row"
    *ngFor="let type of notificationTypes"
    [class.is-selected]="type.value === selectedType"
    (click)="chooseType(type.value)">
    <span>{{ type.label }}</span>
    <i class="fa fa-check" aria-hidden="true" *ngIf="type.value === selectedType"></i>
  </button>
</div>

  <div class="notification-list" *ngIf="!loading">
    <div
      *ngIf="filteredNotifications.length === 0"
      class="no-notifications">
      <i class="fa fa-bell-slash"></i>
      <p>No notifications found</p>
      <span class="no-notifications-hint" *ngIf="selectedFilter !== 'all'">
        Try selecting "All" to see all notifications
      </span>
    </div>

    <div
      *ngFor="let notification of filteredNotifications; trackBy: trackByNotificationId"
      class="notification-item"
      [class.unread]="!notification.read"
      [class.processing]="notification.isProcessing"
      [ngClass]="getPriorityClass(notification.priority)"
      (click)="navigateToAction(notification)">
      
      <!-- Priority indicator bar -->
      <div class="priority-indicator" [ngClass]="getPriorityClass(notification.priority)"></div>
      
      <div class="notification-icon" [ngClass]="getSeverityClass(notification.severity)">
        <i class="fa" [ngClass]="getSeverityIcon(notification.severity)"></i>
      </div>
      
      <div class="notification-content">
        <div class="notification-header-item">
          <h5 class="notification-item-title">
            {{ notification.title }}
            <span class="processing-indicator" *ngIf="notification.isProcessing">
              <i class="fa fa-circle-notch fa-spin"></i>
            </span>
          </h5>
          <span class="notification-time-compact">
            {{ formatTimestamp(notification.timestamp) }}
          </span>
        </div>
        
        <p class="notification-message">
          {{ notification.shortMessage || notification.message }}
        </p>
        
        <!-- Simple progress bar for system notifications (e.g., dashboard refresh) -->
        <div 
          class="simple-progress-container" 
          *ngIf="notification.progress !== undefined && notification.progress !== null && notification.severity === 'updating' && !notification.metadata?.dashboards?.length">
          <div class="simple-progress-bar">
            <div class="simple-progress-fill" [style.width.%]="notification.progress || 0"></div>
          </div>
          <span class="simple-progress-text">{{ notification.progress || 0 }}%</span>
        </div>
        <div
          class="simple-progress-message"
          *ngIf="notification.severity === 'updating' && notification.metadata?.progressMessage">
          {{ notification.metadata.progressMessage }}
        </div>
        
        <!-- Site save steps progress (for site configuration save) -->
        <div 
          *ngIf="notification.metadata?.steps?.length > 0"
          class="save-steps-dropdown"
          (click)="$event.stopPropagation()">
          <button 
            class="dropdown-toggle-btn"
            (click)="toggleStepsDropdown(notification)">
            <i class="fa" [ngClass]="isStepsExpanded(notification) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <span>{{ notification.metadata.steps.length }} steps</span>
            <span class="status-summary">
              ({{ getCompletedStepsCount(notification) }}/{{ notification.metadata.steps.length }} complete)
            </span>
          </button>
          
          <div class="steps-list" *ngIf="isStepsExpanded(notification)">
            <div 
              *ngFor="let step of notification.metadata.steps; let i = index"
              class="step-item"
              [class.completed]="step.status === 'completed'"
              [class.failed]="step.status === 'failed'"
              [class.processing]="step.status === 'processing'"
              [class.pending]="step.status === 'pending'">
              <div class="step-row">
                <div class="step-info">
                  <span class="step-index">{{ i + 1 }}.</span>
                  <span class="step-name">{{ step.name }}</span>
                </div>
                <div class="step-status">
                  <span *ngIf="step.status === 'pending'" class="status-pending">
                    <i class="fa fa-clock-o"></i> Processing
                  </span>
                  <span *ngIf="step.status === 'processing'" class="status-processing">
                    <i class="fa fa-spinner fa-spin"></i> Processing
                  </span>
                  <span *ngIf="step.status === 'completed'" class="status-completed">
                    <i class="fa fa-check-circle"></i> Done
                  </span>
                  <span *ngIf="step.status === 'failed'" class="status-failed">
                    <i class="fa fa-times-circle"></i> Failed
                  </span>
                </div>
              </div>
              <div class="step-progress-bar" *ngIf="step.status === 'processing'">
                <div class="progress-fill" [style.width.%]="step.progress || 0"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Report pages dropdown (works for both single & multi-page reports) -->
        <div 
          *ngIf="notification.metadata?.dashboards?.length > 0"
          class="multi-page-dropdown"
          (click)="$event.stopPropagation()">
          <button 
            class="dropdown-toggle-btn"
            (click)="toggleMultiPageDropdown(notification)">
            <i class="fa" [ngClass]="isMultiPageExpanded(notification) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <span>{{ notification.metadata.dashboards.length }} {{ notification.metadata.dashboards.length === 1 ? 'page' : 'pages' }}</span>
            <span class="status-summary">
              ({{ getCompletedPagesCount(notification) }}/{{ notification.metadata.dashboards.length }} complete)
            </span>
          </button>
          
          <div class="dashboard-list" *ngIf="isMultiPageExpanded(notification)">
            <div 
              *ngFor="let dashboard of notification.metadata.dashboards; let i = index"
              class="dashboard-item"
              [class.completed]="dashboard.status === 'completed'"
              [class.failed]="dashboard.status === 'failed'"
              [class.processing]="dashboard.status === 'processing' || dashboard.status === 'pending'">
              <div class="dashboard-row">
                <div class="dashboard-info">
                  <span class="dashboard-index">{{ i + 1 }}.</span>
                  <span class="dashboard-name">{{ dashboard.name }}</span>
                </div>
                <div class="dashboard-status">
                  <span *ngIf="dashboard.status === 'pending'" class="status-pending">
                    <i class="fa fa-clock-o"></i> Processing
                  </span>
                  <span *ngIf="dashboard.status === 'processing'" class="status-processing">
                    <i class="fa fa-spinner fa-spin"></i> {{ dashboard.progress || 0 }}%
                  </span>
                  <span *ngIf="dashboard.status === 'completed'" class="status-completed">
                    <i class="fa fa-check-circle"></i> Done
                  </span>
                  <span *ngIf="dashboard.status === 'failed'" class="status-failed">
                    <i class="fa fa-times-circle"></i> Failed
                  </span>
                </div>
              </div>
              <div class="dashboard-progress-bar" *ngIf="dashboard.status === 'processing'">
                <div class="progress-fill" [style.width.%]="dashboard.progress || 0"></div>
              </div>
              <div class="dashboard-stale-warning" *ngIf="dashboard.status === 'processing' && dashboard.staleProgressWarning">
                <i class="fa fa-exclamation-triangle"></i>
                <span>{{ dashboard.staleProgressMessage || 'Progress has not changed for the last 3 polls.' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Deleted reports dropdown -->
        <div
          *ngIf="notification.metadata?.deletedReportNames?.length > 0"
          class="multi-page-dropdown"
          (click)="$event.stopPropagation()">
          <button
            class="dropdown-toggle-btn"
            (click)="toggleDeletedDropdown(notification)">
            <i class="fa" [ngClass]="isDeletedExpanded(notification) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            <span>{{ getDeletedReportsCount(notification) }} {{ getDeletedReportsCount(notification) === 1 ? 'report' : 'reports' }}</span>
            <span class="status-summary">(deleted)</span>
          </button>

          <div class="dashboard-list" *ngIf="isDeletedExpanded(notification)">
            <div
              *ngFor="let name of notification.metadata.deletedReportNames; let i = index"
              class="dashboard-item failed">
              <div class="dashboard-row">
                <div class="dashboard-info">
                  <span class="dashboard-index">{{ i + 1 }}.</span>
                  <span class="dashboard-name">{{ name }}</span>
                </div>
                <div class="dashboard-status">
                  <span class="status-failed">
                    <i class="fa fa-times-circle"></i> Deleted
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="notification-meta">
          <!-- Phones show the time here rather than beside the title, which
               frees the whole width for the heading. Hidden above 768px,
               where .notification-time-compact carries it as before. -->
          <span class="notification-time-meta">
            {{ formatTimestamp(notification.timestamp) }}
          </span>
          <span class="notification-type-badge">
            <i class="fa" [ngClass]="getTypeIcon(notification.type)"></i>
            {{ notification.type }}
          </span>
          <span 
            class="badge severity-badge"
            [ngClass]="getSeverityClass(notification.severity)">
            {{ getSeverityLabel(notification) }}
          </span>
        </div>
      </div>
      
      <div class="notification-actions-item">
        <button
          *ngIf="!notification.read"
          class="btn btn-sm btn-link action-btn"
          (click)="markAsRead(notification); $event.stopPropagation()"
          title="Mark as read">
          <i class="fa fa-check"></i>
        </button>
        <button
          class="btn btn-sm btn-link action-btn delete-btn"
          (click)="deleteNotification(notification); $event.stopPropagation()"
          title="Delete">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p>Loading notifications...</p>
  </div>
</div>
